import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TypeRatingComponent} from './type-rating.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    TypeRatingComponent,
  ],
  exports: [
    TypeRatingComponent,
  ],
})
export class TypeRatingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-rating/type-rating.module.ts